import { render } from "./KanbanBoardPage.vue?vue&type=template&id=5c8c4133&ts=true"
import script from "./KanbanBoardPage.vue?vue&type=script&lang=ts"
export * from "./KanbanBoardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__